/**
 * TODO: 4.0
 *
 * - `size` not work with customizeInput
 * - CustomizeInput not feedback `ENTER` key since accessibility enhancement
 */
import classNames from 'classnames';
import * as React from 'react';
import toArray from 'rc-util/lib/Children/toArray';
import omit from 'rc-util/lib/omit';
import CloseCircleFilled from '@haier/icons/CloseCircleFilled';
import { ConfigConsumer } from '../config-provider';
import Select from '../select';
import Input from '../input';
import { isValidElement } from '../_util/reactNode';
import warning from '../_util/warning';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import { useEffect } from 'react';
const { Option } = Select;
function isSelectOptionOrSelectOptGroup(child) {
    return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
}
const AutoComplete = (props, ref) => {
    const { prefixCls: customizePrefixCls, className, dropdownClassName, placeholder, children, dataSource, onSelect, onChange, onEnterPress, onBlur, value, suffix, prefix, allowClear, onlyAllowSearch = true, } = props;
    useBuriedPoint('AutoComplete');
    const handleClear = () => {
        setInputValue('');
        props.onClear && props.onClear();
    };
    const childNodes = toArray(children ? (children) : (React.createElement(Input, { prefix: prefix, suffix: suffix, status: props.status, size: props.size, allowClear: allowClear ? { clearIcon: React.createElement(CloseCircleFilled, { onClick: handleClear }) } : false, placeholder: placeholder, onPressEnter: onEnterPress })));
    // ============================= Input =============================
    let customizeInput;
    if (childNodes.length === 1 &&
        isValidElement(childNodes[0]) &&
        !isSelectOptionOrSelectOptGroup(childNodes[0])) {
        [customizeInput] = childNodes;
    }
    const getInputElement = customizeInput ? () => customizeInput : undefined;
    // 输入框的值
    const [inputValue, setInputValue] = React.useState(onlyAllowSearch === false ? props.value : '');
    useEffect(() => {
        if (onlyAllowSearch === false)
            setInputValue(props.value);
    }, [props.value]);
    const selectedValue = React.useRef(props.value);
    const filterData = () => {
        function traverse(options) {
            if (Array.isArray(options)) {
                options.forEach((item) => {
                    if (item.options) {
                        traverse(item.options);
                    }
                    else {
                        if (props.value && selectedValue.current) {
                            if (item.value === props.value) {
                                if (isValidElement(item.label)) {
                                    setInputValue(item.value);
                                }
                                else {
                                    setInputValue(item.label);
                                }
                            }
                        }
                    }
                });
            }
            else {
                console.warn('AutoComplete options must be an array');
            }
        }
        traverse(props.options);
    };
    React.useEffect(() => {
        if (Array.isArray(props.options)) {
            filterData();
        }
    }, [props.options]);
    React.useEffect(() => {
        //根据选中的value值，显示选中的文本
        selectedValue.current = value;
        filterData();
    }, [value]);
    const handleSelect = (val, option) => {
        if (isValidElement(option.label)) {
            changevalue(option.value, option.value);
        }
        else {
            changevalue(option.label, option.value);
        }
        onSelect && onSelect(val, option);
    };
    const handleChange = (val, option) => {
        changevalue(val, '');
        onChange && onChange(val, option);
    };
    const changevalue = (label, val) => {
        selectedValue.current = val;
        setInputValue(label);
    };
    const handleBlur = (e) => {
        if (!selectedValue.current && onlyAllowSearch)
            setInputValue('');
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    // ============================ Options ============================
    let optionChildren;
    if (childNodes.length && isSelectOptionOrSelectOptGroup(childNodes[0])) {
        optionChildren = children;
    }
    else {
        optionChildren = dataSource
            ? dataSource.map((item) => {
                if (isValidElement(item)) {
                    return item;
                }
                switch (typeof item) {
                    case 'string':
                        return (React.createElement(Option, { key: item, value: item }, item));
                    case 'object': {
                        const { value: optionValue } = item;
                        return (React.createElement(Option, { key: optionValue, value: optionValue }, item.label));
                    }
                    default:
                        warning(false, 'AutoComplete', '`options` is only supports type `string[] | Object[]`.');
                        return undefined;
                }
            })
            : [];
    }
    return (React.createElement(ConfigConsumer, null, ({ getPrefixCls }) => {
        const prefixCls = getPrefixCls('select', customizePrefixCls);
        return (React.createElement(Select, Object.assign({ ref: ref }, omit(props, ['dataSource']), { prefixCls: prefixCls, dropdownClassName: dropdownClassName, className: classNames(`${prefixCls}-auto-complete`, className), mode: Select.SECRET_COMBOBOX_MODE_DO_NOT_USE, onSelect: (val, option) => handleSelect(val, option), onChange: (val, option) => handleChange(val, option), onBlur: handleBlur, 
            // filterOption={false}
            allowClear: false, value: inputValue, placeholder: null }, {
            // Internal api
            getInputElement,
        }), optionChildren));
    }));
};
const RefAutoComplete = React.forwardRef(AutoComplete);
RefAutoComplete.Option = Option;
export default RefAutoComplete;
